// ----------------------------------------------------------------------

const agendadocs = [
  {
    id: 1,
    detailfile: 'test',
    speechfile: 'speech',
    title: 'Title 1'
  },
  {
    id: 2,
    detailfile: 'test2',
    speechfile: 'speech',
    title: 'Title 2'
  },
  {
    id: 3,
    detailfile: 'test3',
    speechfile: 'speech',
    title: 'Title 3'
  }
];

export default agendadocs;
